import styled from 'styled-components';

export const MaxWidthDiv = styled.div<{ mw: string | number }>`
  max-width: ${({ mw }) => (typeof mw === 'number' ? `${mw}px` : mw)};
`;
